import { Injectable } from '@angular/core';
import { ArboService } from 'src/app/services/arbo.service';
import { HttpService } from 'src/app/services/http.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  constructor(
    private arboService: ArboService,
    private httpService: HttpService
  ) { }

  create(data)  { return this.arboService.create('User',data); }
  get(id)       { return this.arboService.get('User',id); }
  update(data)  { return this.arboService.update('User',data); }
  delete(id)    { return this.arboService.delete('User',id); }
  getMemberships() { return this.httpService.get(environment.arboUrl+`/User/memberships`); }

  listAll(offset: number = 0, limit: number = 200) {
    return this.httpService.get(`${environment.arboUrl}/User/?offset=${offset}&limit=${limit}`);
  }
  // getByCPF(cpf) { return this.httpService.get(environment.arboUrl+`/Profile/cpf/${cpf}`); }
  // getByCelular(celular) { return this.httpService.get(environment.arboUrl+`/Profile/celular/${celular}`); }
}
